import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { ReactComponent as BtnBack } from '../../assets/btn-back.svg'; // Importuj SVG obrázok

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const navigate = useNavigate(); // Na navigáciu na vyššiu úroveň

  // Načítame názov evidenčného listu z Reduxu a jeho stav načítavania
  const evidenceListName = useSelector(state => state.evidenceList.current.name);
  const loading = useSelector(state => state.evidenceList.currentLoading);

  // Načítame názov prevádzkového denníka z Reduxu a jeho stav načítavania
  const operationalLogName = useSelector(state => state.operationalLog.logToEdit?.name);
  const operationalLogLoading = useSelector(state => state.operationalLog.logToEditLoading);

  if (location.pathname === '/dashboard') return null;

  // Mapa pre názvy breadcrumbov
  const breadcrumbNameMap = {
    '/dashboard': 'Prehľady',
    '/evidencelist': 'Evidenčné listy',
    '/warehouse': 'Sklady',
    '/container': 'Nádoby',
    '/client': 'Dodávatelia a odberatelia',
    '/branch': 'Prevádzky',
    '/announcement': 'Ohlásenia odpadov',
    '/announcement/detail': 'Detail ohlásenia odpadov',
    '/profile': 'Môj profil',
    '/settings': 'Nastavenia',
    '/billing': 'Predplatné a platby',
    '/account': 'Účet',
    '/account/not-verified': 'Overenie účtu',
    '/account/verified': 'Overenie účtu',
    '/consents': 'Súhlasy',
    '/operational-log': 'Prevádzkový denník',
    '/statistics': 'Štatistiky',
    '/ppwr': 'PPWR',
    '/activity': 'Aktivita používateľov',
  };

  // Funkcia na vygenerovanie URL na vyššiu úroveň breadcrumbu
  const getParentUrl = () => {
    if (pathnames.length > 1) {
      // Ak je viac ako jedna úroveň, vygenerujeme cestu o jednu úroveň vyššie
      return `/${pathnames.slice(0, -1).join('/')}`;
    }
    return null; // Ak sme na najvyššej úrovni, vrátime null
  };

  const parentUrl = getParentUrl();

  const renderTooltipBack = (props) => (
    <Tooltip id="button-tooltip" {...props}>
        Späť
    </Tooltip>
);

  return (
    <>
      <nav>
        <ol>
          <li>
            <Link to="/">
              Domov
            </Link>
          </li>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;

            // Ak sme na detaile evidenčného listu a stránka sa ešte načítava, zobraz loader
            if (isLast && to.startsWith('/evidencelist/') && loading) {
              return (
                <li key={to}>
                  Načítava sa...
                </li>
              );
            }

            // Ak sme na detaile prevádzkového denníka a stránka sa ešte načítava, zobraz loader
            if (isLast && to.startsWith('/operational-log/') && operationalLogLoading) {
              return (
                <li key={to}>
                  Načítava sa...
                </li>
              );
            }

            // Ak sme na detaile evidenčného listu, zobraz jeho názov
            let displayName = breadcrumbNameMap[to] || value;
            if (to.startsWith('/evidencelist/') && evidenceListName) {
              displayName = evidenceListName;
            }
            // Ak sme na detaile prevádzkového denníka, zobraz jeho názov
            if (to.startsWith('/operational-log/') && operationalLogName) {
              displayName = operationalLogName;
            }

            return isLast ? (
              <li key={to} className="active">
                {displayName}
              </li>
            ) : (
              <li key={to}>
                <Link to={to}>
                  {breadcrumbNameMap[to] || value}
                </Link>
              </li>
            );
          })}
        </ol>
      </nav>
      {parentUrl && (
        <div>
          <button
            onClick={() => navigate(parentUrl)}
            style={{
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              padding: '0',
            }}
          >
            <OverlayTrigger placement="top" overlay={renderTooltipBack}>
              <BtnBack
                alt="Späť"
                className="btnBack"
              />
            </OverlayTrigger>
          </button>
        </div>
      )}
    </>
  );
}

export default Breadcrumbs;
